import { useNavigate } from "react-router-dom"

import { Button } from "../../../components/core/Button"
 
export const ValidateEmail = () => {
    
    const navigate = useNavigate()

    const comeBack = () => {
        navigate("/")
    }

    return (
        <>
        <div className="h-screen w-full flex justify-center">
            <div className="w-[430px] h-[258px] grid grid-rows-3 gap-2 bg-[#ffffff] p-4 rounded-lg">
                <h2 className="font-bold text-xl flex w-full justify-center">Tu mail se verificó con éxito</h2>
                <p className="flex w-full justify-center">Se te informará por mail cuando Lavoris apruebe tu empresa</p>
                <Button 
                    type="button"
                    text="Aceptar"
                    className="bg-red-500 font-bold text-white"
                    onClick={comeBack}
                />
            </div>
        </div>
        </>
    )
}